import { render } from "./BasketAside.vue?vue&type=template&id=6d2fe5df"
import script from "./BasketAside.vue?vue&type=script&lang=js"
export * from "./BasketAside.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__